import { ServerSecurityIcon } from './ServerSecurityIcon';

/**
 * author: Austin Andrews
 * id E42A523C-D28D-4AAB-8A86-4816DD872B78
 * name server-security
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/server-security.svg
 * tags
 */
export const ServerShieldIcon = ServerSecurityIcon;
export default ServerShieldIcon